"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _isEmpty = _interopRequireDefault(require("lodash/fp/isEmpty"));

var _baseStatePropTypes = require("./baseStatePropTypes");

var _excluded = ["icon", "icons", "image", "headline", "message", "buttons", "alignment", "fullWidth", "condensed", "outerClassName", "innerClassName", "children"];

var StateButton = function StateButton(_ref) {
  var text = _ref.text,
      className = _ref.className,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      href = _ref.href;
  var buttonClassNames = (0, _classnames.default)('btn btn-primary', 'margin-top-10', className && className); // In case a href is given, render a link button instead

  if (href) {
    return /*#__PURE__*/_react.default.createElement("a", {
      className: buttonClassNames,
      href: href,
      onClick: onClick
    }, text);
  }

  return /*#__PURE__*/_react.default.createElement("button", {
    className: buttonClassNames,
    type: "button",
    onClick: onClick
  }, text);
};

var Icon = function Icon(_ref2) {
  var name = _ref2.name,
      color = _ref2.color,
      className = _ref2.className;
  var iconClassNames = (0, _classnames.default)('rioglyph', color || 'text-color-light', name && name, !className && 'text-size-300pct', className && className);
  return /*#__PURE__*/_react.default.createElement("span", {
    className: iconClassNames
  });
};

var getAlignmentClassName = function getAlignmentClassName(alignment) {
  switch (alignment) {
    case _baseStatePropTypes.ALIGN_LEFT:
      return 'justify-content-start';

    case _baseStatePropTypes.ALIGN_CENTER:
      return 'justify-content-center';

    case _baseStatePropTypes.ALIGN_RIGHT:
      return 'justify-content-end';

    default:
      return 'justify-content-center';
  }
};

var CustomState = function CustomState(props) {
  var icon = props.icon,
      icons = props.icons,
      image = props.image,
      headline = props.headline,
      message = props.message,
      buttons = props.buttons,
      alignment = props.alignment,
      fullWidth = props.fullWidth,
      condensed = props.condensed,
      outerClassName = props.outerClassName,
      innerClassName = props.innerClassName,
      children = props.children,
      remainingProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var wrapperClasses = (0, _classnames.default)('margin-0', 'width-100pct', !fullWidth && 'max-width-600', 'panel-default', 'panel', condensed ? 'padding-10' : 'padding-15', outerClassName && outerClassName);
  var innerClassNames = (0, _classnames.default)('display-flex', 'flex-column', 'align-items-center', 'text-center', condensed ? 'padding-15' : 'padding-25', innerClassName && innerClassName);
  var iconClasses = (0, _classnames.default)(condensed ? 'text-size-16 margin-bottom-10' : 'text-size-h2 margin-bottom-20');
  var iconsClasses = (0, _classnames.default)(condensed ? 'text-size-16 margin-bottom-10' : 'text-size-h2 margin-bottom-20', 'display-flex', 'align-items-center', 'max-width-100pct');
  var headlineClassNames = (0, _classnames.default)(condensed ? 'text-size-h4' : 'text-size-h3 text-size-h2-sm', 'line-height-125rel', 'text-color-dark', 'text-medium', 'width-500', 'max-width-100pct');

  var renderButtons = /*#__PURE__*/_react.default.createElement("div", {
    className: "btn-toolbar margin-top-20"
  }, buttons.map(function (buttonProps, index) {
    return /*#__PURE__*/_react.default.createElement(StateButton, (0, _extends2.default)({
      key: index
    }, buttonProps));
  }));

  var renderIcon = /*#__PURE__*/_react.default.createElement("div", {
    className: iconClasses
  }, /*#__PURE__*/_react.default.createElement(Icon, {
    name: icon
  }));

  var renderIcons = /*#__PURE__*/_react.default.createElement("div", {
    className: iconsClasses
  }, icons.map(function (iconProps, index) {
    return /*#__PURE__*/_react.default.createElement(Icon, (0, _extends2.default)({
      key: index
    }, iconProps));
  }));

  var renderChildren = /*#__PURE__*/_react.default.createElement("div", {
    className: 'width-500 max-width-100pct margin-top-25'
  }, children);

  var renderHeadline = /*#__PURE__*/_react.default.createElement("div", {
    className: headlineClassNames
  }, headline);

  var renderMessage = /*#__PURE__*/_react.default.createElement("div", {
    className: 'text-color-dark margin-top-15 width-500 max-width-100pct'
  }, message);

  var singleOrMultiIcon = (0, _isEmpty.default)(icons) ? renderIcon : renderIcons;
  var imageOrIcon = image ? image : singleOrMultiIcon;
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: "display-flex ".concat(getAlignmentClassName(alignment), " max-width-100pct")
  }, remainingProps), /*#__PURE__*/_react.default.createElement("div", {
    className: wrapperClasses
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: innerClassNames
  }, imageOrIcon, headline && renderHeadline, message && renderMessage, !(0, _isEmpty.default)(buttons) && renderButtons, children && renderChildren)));
};

CustomState.defaultProps = {
  icon: 'rioglyph-rio',
  icons: [],
  buttons: [],
  alignment: _baseStatePropTypes.ALIGN_CENTER,
  fullWidth: false,
  condensed: false
};
CustomState.propTypes = _baseStatePropTypes.baseStatePropTypes;
var _default = CustomState;
exports.default = _default;